/*
 * utils.quasar.dialog.ts
 */
import type { Component } from 'vue';
import { Dialog } from 'quasar';
import { mcUtils } from 'src/utils/utils';
//
export class mcUtilsQuasarDialog {
  // Dialog.create: (opts) => Object // Creates an ad-hoc Dialog; Same as calling $q.dialog(...);
  // // opts :Object - required; Dialog options
  // {
  //   class: String|Array|Object // CSS Class name to apply to the Dialog's QCard
  //   style: String|Array|Object // CSS style to apply to Dialog's QCard
  //   title: String // A text for the heading title of the dialog; Example: Continue?
  //   message: String // A text with ore information about what needs to be input, selected or confirmed; Example: Are you certain you want to continue?
  //   html: Boolean // Render title and message as HTML; This can lead to XSS attacks, so make sure to sanitiize the message
  //   position: String // Position of the Dialog on screen; Standard is centered; Default value: standard; Accepted values: top right bottom left standard
  //   prompt: Object // An object definition of the input field for the prompting question
  //   {
  //     model: String // required; The initial value of the input
  //     type: String // Optional property to determine the input field type; Default value: text; Examples: text number textarea
  //     isValid: (val) => Boolean // Function; Is typed content valid?
  //       // Params: val: String // required; The value of the input
  //       // Return type: Boolean // The text passed validation or not
  //     ...QInputProps: Any // QInput props, like color, label, stacklabel, filled, outlined, rounded, prefix etc
  //     ...nativeAttributes: Object // Any native attributes to pass to the prompt control
  //   }, // Example: prompt(model: this.promptVal, type: 'number')
  //   options: Object // An object definition for creating the selection form content
  //   {
  //     model: String|Array // required; The value of the selection (String if it's pe of selection; Default value: radio; Accepted values: radio checkbox toggle
  //     type: String // The type of selection; Default value: radio; Accepted values: radio checkbox toggle
  //     items: Array // The list of options to interact with; Equivalent to options prop of the QOptionGroup component; Examples: [{label: 'Option 1', value: 'op1'}, {label: 'Option 2', value: 'op2'}, {label: 'Option 3', value: 'op3'}]
  //     isValid: (model) => Boolean // Is the model valid;
  //       // Param model: String|Array // required; The current model (String if it's of type radio or Array otherwise); Examples: opt2 ['opt1'] [] ['opt1','opt3']
  //       // Return type: Boolean // The selection passed validation or not
  //     ...QOptionGroupProps: Any // Any QOptionGroup props; Example: color:'deep-purple-4' inline:true dense:true leftLabel:true
  //     ...nativeAttribute: Object // Any native attribute to pass to the inner QOptionGroup; Example: {moel: this.dialogSelection, type: 'radio', items:[...listOfItems]}
  //     },
  //     progress: Boolean|Object // Display a Quasar spinner (if value is true, then the defaults are used); Useful for conveying the idea that something is happening behind the covers; Tip: use along with persistent, ok: false and update() method
  //     {
  //       // spinner: Component // One of the QSpinner
  //       // color: String // Examples: primary teal teal-10
  //     },
  //     ok: String|Object|Boolean // Props for an 'OK' button
  //       // ...props: Any // See QBtn for available props
  //     cancel: String|Object|Boolean // Props for a 'CANCEL' button
  //       // ...props: Any // See QBtn for available props
  //     focus: String // What button to focus, unless you also have 'prompt' or 'options'; Default value: ok; Accepted values: ok cancel none
  //     stackButtons: Boolean // Makes buttons be stacked instead of vertically aligned
  //     color: String // Color name for component from the Quasar Color Palette; Examples: primary teal teal-10
  //     dark: Boolean // Apply dark mode
  //     persistent: Boolean // User cannot dismiss Dialog if clicking outside of it or hitting ESC key; Also, an app route change won;t dismiss it
  //     noEscDismiss: Boolean // User cannot dismiss Dialog by hitting ESC key; No need to set if if 'persistent' prop is also set
  //     noBackdropDismiss: Boolean // User cannot dismiss Dialog by clicking outside of it; No need to set it if 'persistent' prop is also set
  //     noRouteDismiss: Boolean // Changing route app won't dismiss Dialog; No need to set it if 'persistent' prop is also set
  //     seamless: Boolean // Put Dialog into seamless mode; Does not use a backdrop so user is able to interact with the rest of the page too
  //     maximized: Boolean // Put Dialog into maximized mode
  //     fullWidth: Boolean // Dialog will try to render with same width as the window
  //     fullHeight: Boolean // Dailog will try to render with same height as the window
  //     transitionShow: String // One of Quasar's embedded transitions: Default: scale; Examples: fade scale slide-down
  //     transitionHide: String // One of Quasar's embedded transitions: Default: scale; Examples: fade scale slide-down
  //     component: Component|String // Use custom dialog component; Use along with 'componentProps' prop where possible; Examples: CustomComponent 'custom-component'
  //     componentProps: Object // User defined props which will be forwarded to underlying custom component if 'component' prop is used
  //   }
  //   // Return type: Object; Chainable Object
  //   // Props
  //   // onOK: (callbackFn) => Object // required; Receives a Function param to tell what to do when OK is pressed / option is selected
  //   // // Params: callbackFn: (payload) => void // required; Tell what to do
  //   // // // Params: payload: Any // The payload if called onDialogOK with the parameter or emitted one wiht the 'ok' event;
  //   // // // Examples: 'Quasar Framework' [1,2,6,3] {book: {id:1,name:'Lorem Ipsum'},user:{name:'Lorem J. Ipsum',role:'admin'}}
  //   // // Examples: () => console.log('OK!')
  //   // //           (payload) => Notify.create({type:'positive',message:'Successfull saved `${payload.book.name}` book!})
  //   // // Return type: Object // Chained Object
  //   // onCancel: (callbackFn) => Object // required; Receives a Function param to tell what to do when Cancel is pressed / dialog is dismissed
  //   // // Params: callbackFn: () => void // required; Tell what to do
  //   // // Return type: Object // Chained Object
  //   // onDismiss: (callbackFn) => Object // required; Receives a Function param to tell what to do when the dialog is closed
  //   // // Params: callbackFn: () => void // required; Tell what to do
  //   // // Return type: Object // Chained Object
  //   // hide: () => Object // required; Hides the dialog when called
  //   // // Return type: Object // Chained Object
  //   // update: (opts) => Object // required; Updates the initial properties (given as create() param) except for 'component'
  //   // // Params: opts: Object // required; Props (except 'component') which will overwrite the initial created() params; If create() was invoked with a custom dialog component then this param should contain the new componentProps
  //   // // Return type: Object // Chained Object
  //   )
  //
  public cpifDialogAlert(psColorBG: string, psTitle: string, psMessage: string): void {
    Dialog.create({
      class: "$q.dark.isActive ? 'bg-grey-14' : 'bg-white'",
      title: psTitle,
      message: psMessage,
      ok: true,
      persistent: true,
    });
  }
  //
  public cpifDialogConfirm(
    psTitle: string,
    psMessage: string,
    psMessageCancel: string,
    pfOKCB: (pnID: number) => void,
    pnID: number,
  ): void {
    this.cpifDialogConfirmv2(psTitle, psMessage, psMessageCancel, () => {
      pfOKCB(pnID); // OK CallBack with ID param!
    });
  }
  //
  public cpifDialogConfirmv2(
    psTitle: string,
    psMessage: string,
    psMessageCancel: string,
    pfOKCB: () => void | Promise<void>,
  ): void {
    Dialog.create({
      class: "$q.dark.isActive ? 'bg-grey-14' : 'bg-white'",
      title: psTitle,
      message: psMessage,
      ok: true,
      cancel: true,
      persistent: true,
    })
      .onOk(() => {
        void Promise.resolve(pfOKCB());
      })
      .onCancel(() => {
        if (psMessageCancel && 0 < psMessageCancel.length) {
          mcUtils.cpsoQuasarNotify.cpifNotifyInfo(psMessageCancel);
        }
      });
  }
  //
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public cpifDialogAttachment(psTitle: string, pvcComponent: Component, pxComponentProps: any): void {
    // using custom component
    Dialog.create({
      component: pvcComponent,
      componentProps: pxComponentProps,
    });
  }
}
//#end#
